

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import { ContentNode } from "~/libs/Types";
import TeaserImage from "~/components/Teasers/TeaserImage.vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        TeaserImage
    },

    // Component Properties ----------------------------------------------------

    props: {
        node: {
            type: Object as () => ContentNode,
            required: true
        }
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        link (): string {
            return this.node.path;
        },

        hasImage (): boolean {
            return !!this.node.image;
        }
    }

    // -------------------------------------------------------------------------
});

